// src/pages/SupportPage.js
import API_BASE from '../apiConfig';
import React, { useState, useRef, useEffect } from 'react';
import './SupportPage.css';
import BackToDashboard from "../components/BackToDashboard";

function SupportPage() {
  const [messages, setMessages] = useState([
    { sender: 'bot', text: 'Hej! Ställ din fråga om avfall, transporter eller systemet så svarar jag direkt.' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  async function handleSend(e) {
    e.preventDefault();
    const question = input.trim();
    if (!question) return;

    setMessages((msgs) => [...msgs, { sender: 'user', text: question }]);
    setInput('');
    setLoading(true);

    try {
      // Byt till /api/ask (backend-route som kallar OpenAI)
      const base = API_BASE || ''; // t.ex. https://app.kmaavfall.se/api, annars tom för samma origin
      const res = await fetch(`${base}/ask`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: question })
      });

      if (!res.ok) {
        const t = await res.text().catch(() => '');
        throw new Error(`Serverfel ${res.status}: ${t}`);
      }

      const data = await res.json();
      setMessages((msgs) => [
        ...msgs,
        { sender: 'bot', text: data.reply || 'Kunde inte hämta svar just nu.' }
      ]);
    } catch (err) {
      console.error(err);
      setMessages((msgs) => [
        ...msgs,
        { sender: 'bot', text: 'Tekniskt fel. Försök igen eller kontakta supporten.' }
      ]);
    }
    setLoading(false);
  }

  return (
    <div className="support-container">
      {/* CENTRERAD TILLBAKA-KNAPP */}
      <div
        style={{
          marginBottom: "1.2rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <BackToDashboard label="← Tillbaka till Dashboard" />
      </div>

      <h2 className="support-title">Support & AI-chatt</h2>
      <div className="chatbox">
        {messages.map((msg, i) => (
          <div key={i} className={`chat-message ${msg.sender}`}>
            {msg.text}
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>
      <form className="chat-input-row" onSubmit={handleSend}>
        <input
          type="text"
          placeholder="Skriv din fråga…"
          value={input}
          onChange={e => setInput(e.target.value)}
          disabled={loading}
        />
        <button type="submit" disabled={loading || !input.trim()}>
          {loading ? 'Skickar…' : 'Skicka'}
        </button>
      </form>
      <div className="support-contact">
        <hr />
        <h4>Kontakta oss</h4>
        <p>E-post: support@dittbolag.se</p>
        <p>Telefon: 08-123 45 67</p>
      </div>
    </div>
  );
}

export default SupportPage;
